module.exports = __webpack_public_path__ + "static/media/desktopContactlessIcon.abe2eb37.svg";